/**
 * @file: msg.js
 * @description: 消息存储
 */
import WebSocketManager from "@/utils/socket.js";
// import WebSocketManager from "@/utils/websocketManager.js";
import { Notification } from 'element-ui';
import router from '@/router';
import { getPlatform } from '@tencentcloud/universal-api';
import myJsTools from '@/utils/myJsTools';
import { subscribePolling, unsubscribePolling } from '@/utils/worker/manager';
import { getFetchParamsConfig, handleApiError } from '@/utils/worker/authHelper';

// 全局唯一音频实例
const globalAudio = new Audio(require("@/assets/audio/notice.mp3"));
globalAudio.volume = 1;
globalAudio.muted = false;

// 用 Web Audio API 静音解锁音频上下文，避免首次交互时发声
let audioUnlocked = false;
function unlockAudioContext() {
  if (audioUnlocked) return;
  try {
    const ctx = window.AudioContext ? new window.AudioContext() : new window.webkitAudioContext();
    const buffer = ctx.createBuffer(1, 1, 22050);
    const source = ctx.createBufferSource();
    source.buffer = buffer;
    source.connect(ctx.destination);
    source.start(0);
    if (ctx.state === 'suspended') {
      ctx.resume();
    }
    audioUnlocked = true;
    document.removeEventListener('click', unlockAudioContext);
    document.removeEventListener('keydown', unlockAudioContext);
    document.removeEventListener('touchstart', unlockAudioContext);
  } catch (e) {}
}
document.addEventListener('click', unlockAudioContext);
document.addEventListener('keydown', unlockAudioContext);
document.addEventListener('touchstart', unlockAudioContext);

// 创建隐藏iframe用于播放声音（绕过浏览器自动播放限制）
let audioIframe = null;
let iframeAudio = null;

function createAudioIframe() {
  if (audioIframe) return;
  
  audioIframe = document.createElement('iframe');
  audioIframe.style.display = 'none';
  audioIframe.style.width = '0';
  audioIframe.style.height = '0';
  audioIframe.style.border = 'none';
  audioIframe.style.position = 'absolute';
  audioIframe.style.top = '-9999px';
  audioIframe.style.left = '-9999px';
  
  document.body.appendChild(audioIframe);
  
  // 在iframe中创建音频元素
  const iframeDoc = audioIframe.contentWindow.document;
  iframeDoc.open();
  iframeDoc.write(`
    <!DOCTYPE html>
    <html>
    <head><meta charset="utf-8"></head>
    <body>
      <audio id="noticeAudio" preload="auto">
        <source src="${require("@/assets/audio/notice.mp3")}" type="audio/mpeg">
      </audio>
    </body>
    </html>
  `);
  iframeDoc.close();
  
  // 获取iframe中的音频元素
  iframeAudio = iframeDoc.getElementById('noticeAudio');
  if (iframeAudio) {
    iframeAudio.volume = 1;
    iframeAudio.muted = false;
  }
}

// 页面加载时创建iframe
if (typeof window !== 'undefined') {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', createAudioIframe);
  } else {
    createAudioIframe();
  }
}

const state = {
  wsConnected: false, // WebSocket 连接状态
  wsManager: null, // WebSocket 管理器实例
  msgList: [],
  componentCallbacks: {},
  soundConfig: false,
  audio: globalAudio, // 只引用唯一实例
  audioListener: null, // 存储当前的交互监听器
  latestMsgType: ''
};

const ALLOWED_SOUND_TYPES = [
  'new_order_remind',    // 新单提醒
  // 'prescription_reject_remind', // 处方被驳回
  'prescription_wait_audit_remind' // 处方待审核
];

const mutations = {
  __VUEX_MY_PERSISTEDSTATE_SET__(state, { key, value }) {
    state[key] = value;
  },
  // 设置 WebSocket 连接状态
  SET_WS_STATUS(state, status) {
    state.wsConnected = status;
  },
  // 设置 WebSocket 管理器实例
  SET_WS_MANAGER(state, manager) {
    // 使用 Object.defineProperty 将 WebSocket 管理器设为不可枚举，避免 Vue 响应式系统跟踪
    Object.defineProperty(state, "wsManager", {
      value: manager,
      writable: true,
      enumerable: false,
      configurable: true,
    }); 
  },
  // push消息
  PUSH_MSG(state, msg) {
    msg && state.msgList.push(msg)
  },
  // 移除消息
  REMOVE_MSG(state, msg) {
    state.msgList = state.msgList.filter(item => item.regId !== msg.regId);
  },
  // 跳转路由时移除某个类型的消息
  CLOSE_MSG(state, msgType) {
    state.msgList.forEach(msg => {
      msg.messageType == msgType && msg.msgNotice.close();
    });
    state.msgList = []
  },
  // 注册点击消息的回调
  REGISTER_COMPONENT_CALLBACKS(state, methods) {
    state.componentCallbacks = {...state.componentCallbacks, ...methods};
  },
  // 更新声音配置
  UPDATE_SOUND_CONFIG(state, soundFlag) {
    console.log('test--->888', soundFlag)
    state.soundConfig = soundFlag;
  },
  SET_AUDIO(state, audio) {
    state.audio = audio;
  },
  // 在mutations中添加
  SET_AUDIO_LISTENER(state, listener) {
    state.audioListener = listener;
  },
  SET_LATEST_MSG_TYPE(state, type) {
    state.latestMsgType = type;
  }
};

const getters = {
  getMsgList(state) {
    return state.msgList
  },

  getWsManager(state) {
    return state.wsManager
  }
};

const actions = {
  // 初始化 WebSocket 连接
  async initWebSocket({ commit, dispatch, state }, userId) {
    console.log("初始化 WebSocket连接，docId:", userId);
    if (!userId || userId === "null" || userId === "undefined") {
      console.error("WebSocket初始化失败: 缺少docId");
      return;
    }
    // 如果有实例，并且在链接状态，return
    if (
      state.wsManager &&
      state.wsManager.isConnected &&
      state.wsManager.isConnected()
    ) {
      unsubscribePolling('business/socket/querySocketMessage');
      return;
    }

    // 创建 WebSocket 管理器实例
    const wsManager = new WebSocketManager(userId);
    commit("SET_WS_MANAGER", wsManager);

    // 设置连接状态回调
    wsManager.setCallbacks({
      onOpen: function () {
        window.$tracker.send({
          message: '#NOTICE#消息提醒-websocket_open-socket连接',
          content: JSON.stringify({
            userId: userId
          })
        });
        unsubscribePolling('business/socket/querySocketMessage');
        commit("SET_WS_STATUS", true);
        // console.log("WebSocket连接成功");
      },
      onClose: function (event) {
        window.$tracker.send({
          message: '#NOTICE#消息提醒-websocket_close-socket断开',
          content: JSON.stringify({
            userId: userId,
            event: event
          })
        });
        commit("SET_WS_STATUS", false);
        dispatch('pollingMethod');
        // console.log("WebSocket连接关闭");
      },
      onError: function (error) {
        window.$tracker.send({
          message: '#NOTICE#消息提醒-websocket_error-socket错误',
          content: JSON.stringify({
            userId: JSON.stringify(error)
          })
        });
        commit("SET_WS_STATUS", false);
        dispatch('pollingMethod');
        // console.error("WebSocket连接错误:", error);
      },
    });

    // 建立连接
    wsManager.connect();

    // 监听消息
    wsManager.onmessage((message) => {
      // 过滤心跳消息、连接成功的系统消息
      if (message.messageType && !["heartbeat", "system"].includes(message.messageType)) {
        dispatch("handleNewMessage", message);
      }
    });
  },
  // 关闭 WebSocket 连接
  closeWebSocket({ commit, dispatch, state }) {
    console.log("关闭 WebSocket连接");
    if (state.wsManager) {
      state.wsManager.close();
      // commit("SET_WS_MANAGER", null);
      commit("SET_WS_STATUS", false);
      dispatch('reset_msg');
      dispatch('pausePlayingAudio');
    }
  },
  // 处理新消息
  handleNewMessage({ commit, dispatch, state }, message) {
    console.log("test===>处理新消息", message);
    if(!message.content) return;
    const msg = {
      ...message,
      content: JSON.parse(message.content || '{}')
    };
    commit('SET_LATEST_MSG_TYPE', message.messageType)
    console.log("test--->111处理新消息", msg, router);
    // 判断消息类型
    if([
      'new_order_remind', 
      'prescription_reject_remind', 
      'prescription_wait_audit_remind'
    ].includes(message.messageType)){
      console.log("test--->222处理新消息", msg);
      // 如果是 [新单提醒]、[处方驳回提醒]、[处方待审核提醒] 的消息类型，进行PC内提示、PC外提示、声音提醒
      const obj = state?.msgList.find(item => {
        return item?.content?.regId === msg?.content?.regId
      });
      if(!obj) {
        dispatch('handleNoticeInside', msg);
        dispatch('handleNoticeOutside', msg);
      }
      // if(!(state.audio && state?.audio?.regId == msg?.content?.regId && state?.audio?.msgStatus == msg?.content?.status)) {
        dispatch('handleNoticeSound', msg);
      // }
    } else {
      // [处方状态改变]、[问诊状态改变]不提示,且关闭刚才弹出的消息提示
      dispatch('clearAudioListeners'); // 先清除已有监听器
      dispatch('msgClose', msg);
    }
  },
  // PC内消息提醒
  async handleNoticeInside({ commit, dispatch, state }, message) {
    if(!message || !message.messageType) return;
    console.log("test--->333处理新消息", router.currentRoute.name, message);
    const curRouteName = router.currentRoute.name;
    // 新单消息在抢单区页面不提醒;
    if(['index', 'grabOrderList'].includes(curRouteName) && message.messageType === 'new_order_remind') return;
    // 处方待审核在待审核处方列表页面不提醒;
    if(
      ['trialPartyIndex', 'pharmWait', 'noPass', 'noPassChoose'].includes(curRouteName) && 
      message.messageType === 'prescription_wait_audit_remind'
    ) return;
    let customClass = getPlatform() === 'h5' ? 'message-notification-custom-class message-notification-custom-class-h5' : 'message-notification-custom-class';
    console.log("test--->440处理新消息", message, getPlatform(), customClass);

    const content = message.content;
    if(!content?.messageTitle || !content?.messageContent) return;

    const trackerObj = {
      message_id: content.redId,
      message_type: message.messageType,
      msg_id: message?.content?.regId || '未知',
      notice_type: 'PC内push消息'
    }

    const msgNotice = Notification.success({
        title: `${content?.messageTitle || '消息提醒'}`,
        message: `${content?.messageContent || '您有一条新消息'}`,
        showClose: true,
        duration: 3000,
        customClass,
        onClick: async () => {
          window.$tracker.send({
            message: '#NOTICE#消息提醒-notifications_click-消息点击',
            content: JSON.stringify(trackerObj)
          });
          msgNotice.close();
          dispatch('msgClick', message)
        },
        onClose: () => {
          window.$tracker.send({
            message: '#NOTICE#消息提醒-notifications_click-消息关闭',
            content: JSON.stringify(trackerObj)
          });
          commit('REMOVE_MSG', message)
        }
    });
    window.$tracker.send({
      message: '#NOTICE#消息提醒-notifications_push-消息展示',
      content: JSON.stringify(trackerObj)
    });
    commit('PUSH_MSG', {
      ...message, 
      noticeType: 'inside', 
      msgNotice
    });
  },
  // PC外消息提醒
  async handleNoticeOutside({ commit, dispatch }, message) {
    if(!message || !message.messageType) return;
    // 检查浏览器是否支持Notification API
    if (!("Notification" in window)) {
      return
    }
    // 获取当前用户权限
    let permission = window?.Notification?.permission;
    // 未询问，则询问用户
    if (permission === 'default') {
      window.Notification.requestPermission(function (res) {
        permission = res;
      });
    };
    // 判断权限
    if (permission === "granted") {
      // 监听页面可见性变化
      let isPageVisible = document.visibilityState === 'visible';
      document.addEventListener('visibilitychange', () => {
        isPageVisible = document.visibilityState === 'visible';
      });
      if(isPageVisible) return;

      // 创建通知
      let msgNotice = null;
      const content = message.content;
      if(!content?.messageTitle || !content?.messageContent) return;

      const trackerObj = {
        message_id: content.redId,
        message_type: message.messageType,
        msg_id: message?.content?.regId || '未知',
        notice_type: 'PC外桌面消息'
      }

      msgNotice = new window.Notification(`${content?.messageTitle || '消息提醒'}`, { 
        body: `${content?.messageContent || '您有一条新消息'}`,
        requireInteraction: true 
      });
      commit('PUSH_MSG', {
        ...message, 
        noticeType: 'outside', 
        msgNotice
      });
      window.$tracker.send({
        message: '#NOTICE#消息提醒-notifications_push-消息展示',
        content: JSON.stringify(trackerObj)
      });
      // 3S后关闭提示
      const timer = setTimeout(() => {
        msgNotice.close();
        timer && clearTimeout(timer);
      }, 3000);
      // 3S后自动关闭或者手动关闭，都会触发回调
      msgNotice.onclose = function () {
        timer && clearTimeout(timer);
        window.$tracker.send({
          message: '#NOTICE#消息提醒-notifications_click-消息关闭',
          content: JSON.stringify(trackerObj)
        });
        commit('REMOVE_MSG', message);
      }
    } else {
      console.log('用户拒绝了通知授权')
    }
  },
  // 声音提醒
  async handleNoticeSound({ commit, dispatch, state }, message) {
    if(!message || !message.messageType) return;
    const content = message.content;
    if(!content?.messageTitle || !content?.messageContent) return;

    const needSound = ['new_order_remind', 'prescription_wait_audit_remind'].includes(message.messageType) && myJsTools.getItem("docAllInfo")?.voiceSwitch == '1';
    if (!needSound && message.messageType !== 'prescription_reject_remind') {
      dispatch('clearAudioListeners');
      return;
    }
    // ------------------------- 播放消息提示音频 ---------------------------
    const trackerObj = {
      message_id: content.redId,
      message_type: message.messageType,
      msg_id: message?.content?.regId || '未知',
      notice_type: '声音提醒'
    }

    // 优先使用iframe中的音频播放
    const audioToPlay = iframeAudio || state.audio;
    
    // 停止并重置音频
    try {
      await audioToPlay.pause();
      audioToPlay.currentTime = 0;
    } catch (e) {
      console.log('音频重置失败:', e);
    }
    
    // 设置音频属性
    audioToPlay.loop = message.messageType !== 'prescription_reject_remind';
    audioToPlay.volume = 1;
    audioToPlay.muted = false;

    setTimeout(async() => {
      try {
        await audioToPlay.play();
        window.$tracker.send({
          message: `#NOTICE#消息提醒-notifications_play-声音播放${message.getType == 'polling' ? '-轮询消息' : ''}${iframeAudio ? '-iframe' : ''}`,
          content: JSON.stringify(trackerObj)
        });
      } catch (error) {
        if (error.name !== 'AbortError') {
          console.error('音频播放失败:', error);
        }
        window.$tracker.send({
          message: `#NOTICE#消息提醒-notifications_play-未交互声音播放失败${message.getType == 'polling' ? '-轮询消息' : ''}`,
          content: JSON.stringify(trackerObj)
        });
        const playOnUserInteraction = async () => {
          try {
            await audioToPlay.pause();
            audioToPlay.currentTime = 0;
          } catch (e) {
            console.log('交互后音频重置失败:', e);
          }
          setTimeout(() => {
            audioToPlay.play().catch((err) => {
              console.error('用户交互后播放音频失败:', err.message);
            });
            window.$tracker.send({
              message: `#NOTICE#消息提醒-notifications_play-交互后消息声音播放${message.getType == 'polling' ? '-轮询消息' : ''}`,
              content: JSON.stringify(trackerObj)
            });
            dispatch('clearAudioListeners');
          }, 1000)
        };
        dispatch('clearAudioListeners');
        commit('SET_AUDIO_LISTENER', playOnUserInteraction);
        document.addEventListener('keydown', playOnUserInteraction, { once: true });
        document.addEventListener('touchstart', playOnUserInteraction, { once: true });
        document.addEventListener('click', playOnUserInteraction, { once: true });
      }
    }, 1000)
    // ------------------------- 播放提示音频end ---------------------------
  },
  // 添加清除监听器的action
  clearAudioListeners({ commit, state }) {
    if (state.audioListener) {
      document.removeEventListener('keydown', state.audioListener);
      document.removeEventListener('touchstart', state.audioListener);
      document.removeEventListener('click', state.audioListener);
      commit('SET_AUDIO_LISTENER', null);
    }
  },
  // 注册消息的回调
  registerComponentCallback({ commit }, payload) {
    commit('REGISTER_COMPONENT_CALLBACKS', payload);
  },
  // 消息点击
  async msgClick({ commit, state }, message) {
    if(!message || !message.messageType) return;
    const curRouteName = router.currentRoute.name;
    // ---------------------------- 处方驳回的消息 ----------------------
    if(message.messageType === 'prescription_reject_remind') {
      console.log("test--->441处理新消息", message.content.regId);
      if(!message?.content?.regId) return;
      // PC/H5跳转到问诊中
      if(curRouteName !== 'index'){
        // step1 先跳转到在线诊室页面
        await state.componentCallbacks?.goTo('/index', '', {clickType: 'msg', msgId: message.content.regId});
      }
      // step2 先切换tab到[接诊中](appointment/index.vue)；注：这几个tab是写死的，所以index是固定写死的，如果后续添加tab或者更顺序，需要修改这里
      await state.componentCallbacks?.changeTab(2);
      // step3 再触发卡片的点击事件(appointment/card.vue)
      state.componentCallbacks?.openAddYy({
        clickType: 'msg',
        type: 2, // 0: 已预约, 1: 待接诊, 2: 接诊中, 3: 已结束
        regId: `${message.content.regId}`
      });
    }
    // ------------------------------- end -----------------------------

    // ---------------------------- 处方待审核的消息 ----------------------
    if(message.messageType === 'prescription_wait_audit_remind') {
      console.log("test--->442处理新消息", message, router);
      if(curRouteName !== 'trialPartyIndex'){
        // 切换到审方tab(src/common/tabbar.vue)
        await state.componentCallbacks?.goTo('/trialPartyIndex', '', {clickType: 'msg', msgId: message.content.regId});
      }
    }
    // ------------------------------- end -----------------------------

    // ------------------------------- 新单提醒 -------------------------
    if(message.messageType === 'new_order_remind') {
      console.log("test--->443处理新消息", message, router);
      if(curRouteName !== 'index'){
        // step1: PC/H5：跳转到在线诊室页面;
        await state.componentCallbacks?.goTo('/index', '', {clickType: 'msg', msgId: message.content.regId});
      }
    }
    // ------------------------------- end -----------------------------
  },
  // 消息关闭，停止声音，移除消息 
  msgClose({ commit, dispatch, state }, message) {
    if(!message || !message.messageType) return;
    // 问诊状态发生变化，使用regId匹配; 处方状态发生变化，使用prescriptionId匹配处方待审核的消息
    dispatch('pausePlayingAudio')
    commit('REMOVE_MSG', message);
  },
  // 开关关闭，停止声音
  async pausePlayingAudio({ commit, state}, message) {
    // 同时停止两个音频实例
    try {
      if (state.audio) {
        await state.audio.pause();
      }
      if (iframeAudio) {
        await iframeAudio.pause();
      }
    } catch (e) {
      console.log('停止音频失败:', e);
    }
    commit('SET_AUDIO_LISTENER', null);
  },
  reset_msg({commit, dispatch}) {
    commit('PUSH_MSG', null);
    commit('REGISTER_COMPONENT_CALLBACKS', {});
    dispatch('pausePlayingAudio')
  },
  pollingMethod({commit, dispatch}) {
    let docId = '';
    if (myJsTools.getItem('docUserInfo') && myJsTools.getItem('docUserInfo').docId) {
      docId = myJsTools.getItem('docUserInfo').docId;
    };
    if(!docId) return;
    const config = getFetchParamsConfig({
      data: {},
      interval: 3000,
      docName: myJsTools.getItem("docUserInfo")?.docName || '',
      notCompare: true,
    })
    subscribePolling('business/socket/querySocketMessage', config,(err, res) => {
      if (err) return;

      // 统一处理 token 过期（关键！）
      if (handleApiError(res, { fromPolling: true })) return; // 已跳转登录，无需后续处理
      
      // 业务成功
      if (res?.code === 20000) {
        const messageList = res?.data?.socketDetailRespVos || [];
        if(messageList.length > 0) {
          messageList.forEach(message => {
            dispatch("handleNewMessage", {
              content: JSON.stringify(message) || '',
              messageType: message.messageType,
              getType: 'polling'
            });
          });
        } else {
          dispatch('pausePlayingAudio');
        }
        
      } 
      // 其他业务错误（非 token 过期），可选择提示用户
      else if (res?.message) {
        console.warn('业务错误:', res.message);
      }
    });
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
